(function () {
	const splitIntoWords = (text) => {
		return text
			.split(/(\s+)/)
			.map((word) =>
				word.trim()
					? `<span class="word"><span class="word-inner">${word}</span></span>`
					: " "
			)
			.join("");
	};

	const prepareSlideContent = (slide, speed) => {
		slide
			.querySelectorAll(".animated-lines .line-inner")
			.forEach((lineInner) => {
				lineInner.style.transform = "translateY(0)";
				lineInner.innerHTML = splitIntoWords(lineInner.textContent);

				lineInner.querySelectorAll(".word-inner").forEach((word) => {
					word.style.transition = `transform ${speed}ms ease`;
				});
			});

		// Setup fade elements
		slide.querySelectorAll(".fade-element").forEach((element) => {
			element.style.transition = `opacity ${speed}ms ease`;
			element.style.opacity = slide.classList.contains("swiper-slide-active")
				? "1"
				: "0";
		});
	};


	const slideshow = () => {
		$(".slideshow-section").each(function () {
			if ($(this).hasClass("slider_started")) {
				return "";
			}
			$(this).addClass("slider_started");
			const id = $(this).attr("id");
			const box = $(this).find(".slideshow");
			const autoplay = box.data("autoplay");
			const stopAutoplay = box.data("stop-autoplay");
			const delay = box.data("delay") * 1000;
			const speed = box.data("speed") * 1000;
			const slideCount = box.data("count");
			const loop = slideCount == 1 ? false : true;

			if (autoplay) {
				autoplayParm = {
					autoplay: {
						delay: delay,
						pauseOnMouseEnter: stopAutoplay,
						disableOnInteraction: false,
						waitForTransition: true,
					},
				};
			} else {
				autoplayParm = {};
			}
			const swiperParms = {
				speed: speed,
				slidesPerView: 1,
				spaceBetween: 0,
				autoHeight: false,
				keyboard: true,
				loopAdditionalSlides: 0,
				calculateHeight: false,
			};

			const swiperImg = new Swiper(`#${id} .slideshow__swiper_img`, {
				...swiperParms,
				effect: "fade",
				on: {
					slideChange: () => {
						box.css("--bullet-duration", `${delay + speed}ms`);
					},
					slideChangeTransitionStart: function (swiper) {
						let bullets = document.querySelectorAll(
							".swiper-pagination-bullet"
						);
						let activeIndex = swiper.realIndex;
						if (autoplay) { 
							bullets.forEach((bullet, index) => {
								bullet.classList.remove("prev", "next");
								if (index === activeIndex - 1) {
									bullet.classList.add("prev");
								}
								if (index === activeIndex + 1) {
									bullet.classList.add("next");
								}
							});
						}
					},
					slideNextTransitionStart: function () {
            let bullets = document.querySelector(
                `#${id} .swiper-pagination-bullet.next`
            );
					 let x =	document.querySelectorAll(`#${id} .swiper-pagination-bullet`)
						
						if(autoplay) {
							if (bullets) {
									bullets.classList.add('opacity-0');
									setTimeout(() => {
											bullets.classList.remove('opacity-0');
									}, speed);
							}
							
							if (x[x.length - 1].classList.contains('swiper-pagination-bullet-active') && x.length == 3)   {
								
								setTimeout(() => {
									x[1].classList.remove('prev')
									//x[x.length - 1].classList.add('prev')
							}, speed);
							}
						}
        },
				},
				...autoplayParm,
			});
			const swiperText = new Swiper(`#${id} .slideshow__swiper_text`, {
				...swiperParms,

				effect: "creative",
				creativeEffect: {
					prev: {
						translate: [0, 0, 0],
					},
					next: {
						translate: [0, 0, 0],
					},
				},
				slidesPerView: 1,
				navigation: {
					nextEl: `#${id} .swiper-btn--next`,
					prevEl: `#${id} .swiper-btn--prev`,
				},
				pagination: {
					el: `#${id} .swiper-pagination`,
					renderBullet: function (index, className) {
						return (
							'<span class="' + className + '">' + "0" + (index + 1) + "</span>"
						);
					},
				},
				on: {
					init: function () {
						this.slides.forEach((slide) => {
							prepareSlideContent(slide, speed);

							const productCard = slide.querySelector(".slider-product-card");
							if (productCard) {
								productCard.style.transition = `opacity ${speed}ms ease`;
								productCard.style.opacity = slide.classList.contains(
									"swiper-slide-active"
								)
									? "1"
									: "0";
							}
						});

						// Initialize text animations for first slide
						const currentSlide = this.slides[this.activeIndex];

						// Word animations (existing)
						currentSlide.querySelectorAll(".word-inner").forEach((word) => {
							word.style.transition = "none";
							word.style.transform = "translateY(100%)";
							void word.offsetWidth;
							word.style.transition = `transform ${speed / 1000}s ease`;
							word.style.transform = "translateY(0)";
						});

						currentSlide
							.querySelectorAll(".fade-element")
							.forEach((element) => {
								element.style.transition = "none";
								element.style.opacity = "0";
								void element.offsetWidth;
								element.style.transition = `opacity ${speed / 1000}s ease`;
								element.style.opacity = "1";
							});
					},
					slideChangeTransitionStart: function (swiper) {
						let bullets = document.querySelectorAll(
							".swiper-pagination-bullet"
						);
						let activeIndex = swiper.realIndex;
						if ( !autoplay) {
							bullets.forEach((bullet, index) => {
								bullet.classList.remove("prev", "next");
								if (index === activeIndex - 1) {
									bullet.classList.add("prev");
								}
								if (index === activeIndex + 1) {
									bullet.classList.add("next");
								}
							});
						 }
					},
					
					slideChange: function () {
						const prevSlide = this.slides[this.previousIndex];
						const nextSlide = this.slides[this.activeIndex];
					

						if (prevSlide) {
							const prevProduct = prevSlide.querySelector(
								".slider-product-card"
							);
							if (prevProduct) {
								prevProduct.style.opacity = "0";
							}
							// Fade out elements
							prevSlide.querySelectorAll(".fade-element").forEach((element) => {
								element.style.opacity = "0";
							});
						}

						if (nextSlide) {
							const nextProduct = nextSlide.querySelector(
								".slider-product-card"
							);
							if (nextProduct) {
								nextProduct.style.opacity = "1";
							}

							// Fade in elements
							nextSlide.querySelectorAll(".fade-element").forEach((element) => {
								element.style.opacity = "1";
							});
						}

						prevSlide.querySelectorAll(".word-inner").forEach((word) => {
							word.style.transition = "none";
							word.style.transform = "translateY(0)";
							void word.offsetWidth;
							word.style.transition = `transform ${speed / 1000}s ease`;
							word.style.transform = "translateY(-100%)";
						});

						nextSlide.querySelectorAll(".word-inner").forEach((word) => {
							word.style.transition = "none";
							word.style.transform = "translateY(100%)";
							void word.offsetWidth;
							word.style.transition = `transform ${speed / 1000}s ease`;
							word.style.transform = "translateY(0)";
						});
					},
					slidePrevTransitionStart: function () {
            let bullets = document.querySelector(
                `#${id} .swiper-pagination-bullet.prev`
            );
						if(!autoplay) {
							if (bullets) {
									bullets.classList.add('opacity-0');
									setTimeout(() => {
											bullets.classList.remove('opacity-0');
									}, speed);
							}
						}
        },
				},
		
			});
			
	


			swiperImg.controller.control = swiperText;
			swiperText.controller.control = swiperImg;

			const swiper = new Swiper(`#${id} .slideshow__swiper`, swiperParms);


			swiper.on("slideChange", function () {
				box.css("--bullet-duration", `${delay + speed}ms`);
			});
			swiper.on("beforeTransitionStart", function () {
				colorScheme(this);
			});
			swiper.on("slideChange", function () {
				colorScheme(this);
		
			});

			function colorScheme(context) {
				//const parent = $(context.el).parent();
				const parent = box.find(".slideshow-bottom");
				const activeIndex = context.activeIndex;
				const activeSlide = context.slides[activeIndex];
				const changeItems = [parent[0]];
				const colorScheme = $(activeSlide)
					.find(".slideshow-slide")
					.data("color-scheme");
				changeItems.forEach((item) => {
					const classes = item.classList;
					for (let className of classes) {
						if (/color-background-\d+$/.test(className)) {
							item.classList.remove(className);
						}
					}
					item.classList.add(colorScheme);
				});
			}
		});
	};

	document.addEventListener("DOMContentLoaded", function () {
		slideshow();
		document.addEventListener("shopify:section:load", function () {
			slideshow();
		});
	});
})();
